import React, { useMemo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import LineGraph from "../components/LineGraph";
import { useTranslation } from "react-i18next";
import { usePartnerEngagement, usePartnerReach, usePartners, usePartnerSumDivided } from "../query/hooks";
import DonutGraph from "../components/DonutGraph";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import ArrowScroll from "../components/ArrowScroll";
import BestPostsCards from "../components/BestPostsCards";


const ValueDividedPerson = () => {
  const location = useLocation();
  const history = useHistory();
  const search = useMemo(() => new URLSearchParams(location.search), [location]);
  const {data} = usePartners();

  const options = data?.map(partner => partner.name);
  const partner = search.get('partner') ?? data?.[0]?.name;


  const onOptionChange = (option) => {
    history.replace({
      search: `?partner=${option}`
    });
  }
  const {t} = useTranslation();
  const selectedPartnerId = data?.find(brand => brand.name === partner)?.id ?? data?.[0]?.id;

  return (
    <div className="container-fluid p-0 value-person-view">
      <div className="mb-2">
        <ArrowScroll selectedValue={partner} options={options} onOptionChange={onOptionChange} />
      </div>
      <Row>
        <Col sm={12} md={6} className="mb-4">
          <Card className="mini-stat bg-card text-white">
            <CardBody>
              <h4 className="card-title mb-4">{t("BRAND EXPOSURE")}</h4>
              <LineGraph
                useGraphQuery={usePartnerReach}
                queryParams={[selectedPartnerId]}
                chart={{
                  height: '250px',
                }}
                showInLegend={false}
              />
            </CardBody>
          </Card>
        </Col>
        <Col sm={12} md={6} className="mb-4">
          <Card className="mini-stat bg-card text-white">
            <CardBody>
              <h4 className="card-title mb-4">{t("BRAND ENGAGEMENTS")}</h4>
              <LineGraph
                useGraphQuery={usePartnerEngagement}
                queryParams={[selectedPartnerId]}
                chart={{
                  height: '250px',
                }}
                showInLegend={false}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12} className="mb-4">
          <Card className="mini-stat bg-card text-white">
            <CardBody>
              <h4 className="card-title mb-4">{t('Value per media')}</h4>
                <DonutGraph
                  useGraphQuery={usePartnerSumDivided}
                  queryParams={[selectedPartnerId]}
                  chart={{
                    height: '200px',
                  }}
                />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="mb-4">
          <Card className="mini-stat bg-card text-white">
            <CardBody>
              <h4 className="card-title mb-4">
                {t("Beste poster sosiale medier")}
              </h4>
              <BestPostsCards
                params={{ variant: "partner", variantId: selectedPartnerId }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  date: state.date,
  selectedCurrency: state.currency.selectedCurrency,
	tenant: state.auth.tenant,
});

export default connect(mapStateToProps)(ValueDividedPerson);
